import {
  TrackingPageContext,
  trackContentView,
} from '@aboutyou/legacy-tracking-sdk';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {useConvertUserAndSessionToCustomer} from '../trackerComponents/TrackCustomer/useConvertUserAndSessionToCustomer';
import {trackCustomerDataOnce} from '../utils/trackCustomerDataOnce';
import {useTracking} from '../utils/utils';

interface Props {
  breadcrumbsPath?: string;
  pageTitle: string;
  overridePageProps?: {type?: string; id?: number};
  onFired?: () => void;
}

export const useTrackContentView = () => {
  const getPageContext = useTrackingPageContextCallback();
  const {TrackingClient} = useTracking();
  const customer = useConvertUserAndSessionToCustomer();

  return ({pageTitle, overridePageProps, onFired}: Props) => {
    if (!customer) {
      return;
    }
    const pageContext = getPageContext();

    trackCustomerDataOnce(TrackingClient, customer);
    TrackingClient.track(
      trackContentView({
        page: {
          ...pageContext,
          ...overridePageProps,
          title: pageTitle,
        } as unknown as TrackingPageContext,
      }),
    );
    onFired?.();
  };
};
